import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import SdkContext from "../../utilities/contexts/sdk/sdkContext";
import Loading from "../Loading";
import { clearPhotoPrivacy } from "../../utilities/helpers/photoPrivacyHelper";

const SdkLayout: React.FC = () => {
  const [token, setToken] = useState<string | null>(localStorage.getItem("sdk_token") || null);
  const [loading, setLoading] = useState<boolean>(false);
  const [callback, setCallback] = useState<string | null>(localStorage.getItem("sdk_callback") || null);
  const [serviceType, setServiceType] = useState<string | null>(localStorage.getItem("sdk_service_type") || null);
  const [requestId, setRequestId] = useState<string | null>(localStorage.getItem("sdk_request_id") || null);

  const handleLogin = (newToken: string, newCallback: string, newServiceType: string, newRequestId?: string) => {
    setToken(newToken);
    setCallback(newCallback);
    setServiceType(newServiceType);
    setRequestId(newRequestId || null);
  };

  const handleLogout = () => {
    setToken(null);
    clearPhotoPrivacy();
    setCallback(null);
    setServiceType(null);
    setRequestId(null);
  };

  const handleLoading = (newLoading: boolean) => {
    setLoading(newLoading);
  };

  return (
    <SdkContext.Provider
      value={{
        token,
        loading,
        handleLogin,
        handleLogout,
        handleLoading,
        callback,
        serviceType,
        requestId,
      }}
    >
      {loading && <Loading />}
      <Outlet />
    </SdkContext.Provider>
  );
};

export default SdkLayout;
